export interface CacheProject {
  name: string; // API path prefix, e.g. 'tenantservice'
  label: string; // display label shown in the UI
}

// Every project below exposes the same 3 cache endpoints:
//   GET  {name}/CacheManagement/prefixes
//   POST {name}/CacheManagement/flush
//   POST {name}/CacheManagement/clear   { prefixes: string[] }
// Add a new backend service here to have it show up in Settings > Cache Data automatically.
export const CACHE_PROJECTS: CacheProject[] = [
  { name: 'tenantservice', label: 'Tenant Service' },
  // { name: 'patchcenterservice', label: 'Patch Center Service' },
  { name: 'patchreposervice', label: 'Patch Repo Service' },
  // { name: 'assetmgtservice', label: 'Asset Management Service' },
  // { name: 'softwaredeploymentservice', label: 'Software Deployment Service' },
  { name: 'dashboardservice', label: 'Dashboard Service' },
  // { name: 'grouppolicyservice', label: 'Group Policy Service' },
  { name: 'agentapi', label: 'Agent API' },
  // { name: 'authservice', label: 'Auth Service' },
  { name: 'vulnerabilityservice', label: 'Vulnerability Service' },
];
